<template>
  <!-- Drawer variant: an expandable group with one item per locale. -->
  <v-list-group v-if="variant === 'list'" prepend-icon="mdi-translate">
    <template v-slot:activator="{ props }">
      <v-list-item v-bind="props" data-testid="locale-select-drawer-activator">
        <v-list-item-title>{{ languageName($i18n.locale) }}</v-list-item-title>
      </v-list-item>
    </template>
    <v-list-item
      v-for="(item, i) in locales"
      :key="item"
      :data-testid="'locale-option-drawer-' + item"
      @click="localeChange(i)"
    >
      <template v-slot:prepend>
        <v-img :src="flags[item]" width="24" max-height="24" class="mr-3" alt=""></v-img>
      </template>
      <v-list-item-title>{{ languageName(item) }}</v-list-item-title>
    </v-list-item>
  </v-list-group>

  <!-- App-bar variant: the flag button with a menu. -->
  <v-menu v-else bottom left>
    <template v-slot:activator="{ props }">
      <v-btn
        icon
        v-bind="props"
        :aria-label="$t('Změnit jazyk')"
        data-testid="locale-select-activator"
      >
        <v-img
          v-if="flags[$i18n.locale]"
          max-height="24"
          max-width="24"
          width="24"
          :src="flags[$i18n.locale]"
          alt=""
        ></v-img>
        <span v-else class="text-button">{{ $i18n.locale.toUpperCase() }}</span>
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-for="(item, i) in locales" :key="i" :data-testid="'locale-option-' + item" @click="localeChange(i)">
        <template v-slot:prepend>
          <v-img :src="flags[item]" width="24" max-height="24" class="mr-3" alt=""></v-img>
        </template>
        <v-list-item-title>{{ languageName(item) }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// Explicit imports: Vite transforms asset URLs on plain <img> tags only, so a literal
// src string on v-img ships to the browser unresolved (MOB-189).
import LanguageUtil from "@/libs/LanguageUtil";
import flagCs from "@/assets/flag_cs.png";
import flagEn from "@/assets/flag_en.png";
import flagDe from "@/assets/flag_de.png";
import flagSk from "@/assets/flag_sk.png";
import flagHu from "@/assets/flag_hu.png";
import flagPl from "@/assets/flag_pl.png";

export default {
  name: "LocaleSelect",

  props: {
    variant: {
      type: String,
      default: "menu",
    },
  },

  data: () => ({
    flags: {
      cs: flagCs,
      en: flagEn,
      de: flagDe,
      sk: flagSk,
      hu: flagHu,
      pl: flagPl,
    },
  }),

  computed: {
    locales() {
      return this.$store.getters.locales;
    },
  },

  methods: {
    // Endonyms, not translations: a locale is named in itself in every locale (MOB-129).
    languageName(code) {
      return LanguageUtil.label(code);
    },

    localeChange(loc) {
      this.$i18n.locale = this.locales[loc];
      this.$store.dispatch("localeChange", this.locales[loc]);
      this.$router.push({
        name: this.$route.name,
        query: {lang: this.$i18n.locale}
      });
    },
  },
};
</script>
